<template>
    <div>
     <!-- 添加备注弹框 -->
     <el-dialog  
      v-if="flags!=1"
      :visible.sync="exportVisible"
      title="添加备注"
       width="400px"
      :before-close="handleDialogClose1"
      :close-on-click-modal="false"  
     >
     <el-form
        ref="exportForm"
        :model="exportForm"
        label-width="85px"
        label-position="left"
      >
        <el-form-item label="添加备注：">
          <el-input
            type="textarea"
            v-model="exportForm.remark"
            maxlength="20"
            show-word-limit
            rows="3"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button  @click="handleDialogClose1">取消</el-button>
        <el-button type="primary" @click="checkRecord1">效果导出</el-button>
      </span>
     </el-dialog>
     <!-- 生成报表中 -->
     <el-dialog :visible.sync="createStatement" custom-class="base-dialog" width="30%" title="提示"  :before-close="handleDialogClose">
        <div class="create">
            <div style="text-align: center;margin-top: 20px;" >
                <img src="../assets/images/finish.png" alt="" class="size">
            </div>
            <div class="generating">报表生成中...</div>
            <div class="color">生成完成后，在后台管理-导出管理下载报表</div>
        </div>
        <div class="dialog-btn">
            <el-button  @click="handleDialogClose">关闭</el-button>
            <el-button type="primary" @click="checkRecord">查看记录</el-button>
        </div>
     </el-dialog>
    </div>
</template>
<script>
export default {
    name: "generate_report",
    props:{
      control: {
        type: Boolean,
        default: false,
      },
      flags:null
    },
    data() {
        return {
            exportVisible:false,//添加备注
            createStatement:false,
            exportForm: { //备注
               remark: "",
            },
        }
    },
    created() {
    },
    computed: {
    },
    mounted:function(){
       this.exportVisible = this.control; 
       if(this.flags==1){
        this.createStatement = this.control; 
       }
    },
    methods:{
      handleDialogClose(){
         this.$emit("transData",false);
      },
      //查看记录   
      checkRecord(){
        let routeUrl = this.$router.resolve({
           path: "/backstage/export_management",
         });
        window.open(routeUrl.href, "_blank");
      },
      //添加备注关闭弹框
      handleDialogClose1(){
        this.exportVisible = false
        this.$emit("transData",false);
      },
      //效果导出
    checkRecord1(){
       this.createStatement = true
       this.$emit("transData1",this.exportForm.remark);
      }
    }
}
</script>

<style lang='scss' scoped>
.create {
    width: 100%;
    text-align: center;
    .size{
        width: 56px;
        height: 56px;
    }

    .el-icon-check {
        font-size: 26px;
        color: #FE4D45;
        font-weight: 700;
    }
    .generating {
        font-size: 20px;
        font-weight: 700;
        color: #FE4D45;
        margin: 20px 0 10px 0;
    }
    .color {
        color: #666;
    }
}

</style>